export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9217.53cb12f0.jpg";